import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import BASE_URL from "../config";
import {
  FaSignOutAlt,
  FaDownload,
  FaSave,
  FaUserEdit,
} from "react-icons/fa";

export default function StudentDashboard() {
  const navigate = useNavigate();

  const student = JSON.parse(
    localStorage.getItem("student")
  );

  const [editable, setEditable] = useState(false);

  const [form, setForm] = useState({
    student_name: "",
    father_name: "",
    mother_name: "",
    date_of_birth: "",
    admission_class: "",
    mobile_number: "",
    whatsapp_number: "",
    permanent_address: "",
    photo_path: "",
  });

  const [photo, setPhoto] = useState(null);

  useEffect(() => {
    if (!student) {
      navigate("/student/login");
      return;
    }

    fetchStudent();
  }, []);

  const fetchStudent = async () => {
    try {
      const response = await fetch(
        `${BASE_URL}/api/student/${student.id}`
      );

      const data = await response.json();

      if (data.success) {
        setForm(data.student);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleChange = (e) => {
    setForm({
      ...form,
      [e.target.name]: e.target.value,
    });
  };

  const handlePhoto = (e) => {
    setPhoto(e.target.files[0]);
  };

  const handleUpdate = async () => {
    try {
      const formData = new FormData();

      formData.append(
        "student_name",
        form.student_name
      );

      formData.append(
        "father_name",
        form.father_name
      );

      formData.append(
        "mother_name",
        form.mother_name
      );

      formData.append(
        "mobile_number",
        form.mobile_number
      );

      formData.append(
        "whatsapp_number",
        form.whatsapp_number
      );

      formData.append(
        "permanent_address",
        form.permanent_address
      );

      if (photo) {
        formData.append("photo", photo);
      }

      const response = await fetch(
        `${BASE_URL}/api/student/update/${student.id}`,
        {
          method: "PUT",
          body: formData,
        }
      );

      const data = await response.json();

      if (data.success) {
        alert("Details updated successfully");

        fetchStudent();

        setEditable(false);
      } else {
        alert(data.message);
      }
    } catch (error) {
      console.log(error);

      alert("Update failed");
    }
  };

  const logout = () => {
    localStorage.removeItem("student");

    navigate("/student/login");
  };

  const downloadHallticket = () => {
    navigate(`/student/hallticket/${student.id}`);
    //navigate(`/hallticket/${student.id}`);
  };

  return (
    <div style={styles.page}>
      {/* HEADER */}
      <div style={styles.header}>
        <h2 style={styles.title}>
          Student Dashboard
        </h2>

        <button
          style={styles.logoutBtn}
          onClick={logout}
        >
          <FaSignOutAlt />
          Logout
        </button>
      </div>

      {/* MAIN CARD */}
      <div style={styles.card}>
        {/* LEFT */}
        <div style={styles.leftSection}>
          <img
            src={
              form.photo_path
                ? `${BASE_URL}${form.photo_path}`
                : "https://cdn-icons-png.flaticon.com/512/149/149071.png"
            }
            alt="student"
            style={styles.photo}
          />

          <input
            type="file"
            onChange={handlePhoto}
            disabled={!editable}
          />

          <h2 style={styles.studentName}>
            {form.student_name}
          </h2>

          <div style={styles.noticeBox}>
            <h3>Important Notice</h3>

            <p>
              Please verify all details before
              downloading hall ticket.
            </p>

            <p>
              Contact school office if any
              correction required.
            </p>
          </div>

          <button
            style={styles.hallticketBtn}
            onClick={downloadHallticket}
          >
            <FaDownload />
            Download Hall Ticket
          </button>
        </div>

        {/* RIGHT */}
        <div style={styles.rightSection}>
          {/* CHECKBOX */}
          <div style={styles.checkboxRow}>
            <input
              type="checkbox"
              checked={editable}
              onChange={(e) =>
                setEditable(e.target.checked)
              }
            />

            <span>
              I confirm that I want to edit my
              details
            </span>
          </div>

          <div style={styles.grid}>
            <Field
              label="Student Name"
              name="student_name"
              value={form.student_name}
              onChange={handleChange}
              editable={editable}
            />

            <Field
              label="Father Name"
              name="father_name"
              value={form.father_name}
              onChange={handleChange}
              editable={editable}
            />

            <Field
              label="Mother Name"
              name="mother_name"
              value={form.mother_name}
              onChange={handleChange}
              editable={editable}
            />

            <Field
              label="Date of Birth"
              name="date_of_birth"
              value={
                form.date_of_birth
                  ? form.date_of_birth.split("T")[0]
                  : ""
              }
              editable={false}
            />

            <Field
              label="Admission Class"
              name="admission_class"
              value={form.admission_class}
              editable={false}
            />

            <Field
              label="Mobile Number"
              name="mobile_number"
              value={form.mobile_number}
              onChange={handleChange}
              editable={editable}
            />

            <Field
              label="WhatsApp Number"
              name="whatsapp_number"
              value={form.whatsapp_number}
              onChange={handleChange}
              editable={editable}
            />
          </div>

          {/* ADDRESS */}
          <div style={{ marginTop: 20 }}>
            <label style={styles.label}>
              Permanent Address
            </label>

            <textarea
              name="permanent_address"
              value={form.permanent_address}
              onChange={handleChange}
              readOnly={!editable}
              style={styles.textarea}
            />
          </div>

          {/* UPDATE */}
          {editable && (
            <button
              style={styles.updateBtn}
              onClick={handleUpdate}
            >
              <FaSave />
              Update Details
            </button>
          )}
        </div>
      </div>
    </div>
  );
}

function Field({
  label,
  name,
  value,
  onChange,
  editable,
}) {
  return (
    <div>
      <label style={styles.label}>
        {label}
      </label>

      <input
        type="text"
        name={name}
        value={value || ""}
        onChange={onChange}
        readOnly={!editable}
        style={styles.input}
      />
    </div>
  );
}

const styles = {
  page: {
    minHeight: "100vh",
    background: "#eef2f7",
    padding: 20,
    fontFamily: "Segoe UI",
  },

  header: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: 20,
    flexWrap: "wrap",
    gap: 10,
  },

  title: {
    color: "#0b2d59",
  },

  logoutBtn: {
    background: "#d9534f",
    color: "#fff",
    border: "none",
    padding: "10px 18px",
    borderRadius: 8,
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    gap: 8,
    fontWeight: "bold",
  },

  card: {
    display: "flex",
    gap: 20,
    flexWrap: "wrap",
    background: "#fff",
    borderRadius: 15,
    padding: 20,
    boxShadow: "0 5px 20px rgba(0,0,0,0.1)",
  },

  leftSection: {
    flex: "1 1 280px",
    textAlign: "center",
  },

  rightSection: {
    flex: "2 1 500px",
  },

  photo: {
    width: 180,
    height: 180,
    borderRadius: "50%",
    objectFit: "cover",
    border: "5px solid #0b2d59",
    marginBottom: 15,
  },

  studentName: {
    marginTop: 15,
    color: "#0b2d59",
  },

  noticeBox: {
    background: "#ffd54f",
    padding: 15,
    borderRadius: 10,
    marginTop: 20,
    textAlign: "left",
    lineHeight: 1.6,
  },

  hallticketBtn: {
    width: "100%",
    marginTop: 20,
    background: "#002b5b",
    color: "#fff",
    border: "none",
    padding: 14,
    borderRadius: 8,
    cursor: "pointer",
    fontWeight: "bold",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    gap: 10,
  },

  checkboxRow: {
    display: "flex",
    alignItems: "center",
    gap: 10,
    marginBottom: 20,
    color: "red",
    fontWeight: "bold",
  },

  grid: {
    display: "grid",
    gridTemplateColumns:
      "repeat(auto-fit,minmax(250px,1fr))",
    gap: 20,
  },

  label: {
    display: "block",
    marginBottom: 6,
    fontWeight: "bold",
    color: "#333",
  },

  input: {
    width: "100%",
    padding: 12,
    borderRadius: 8,
    border: "1px solid #ccc",
    background: "#f4f4f4",
    fontSize: 15,
  },

  textarea: {
    width: "100%",
    minHeight: 120,
    padding: 12,
    borderRadius: 8,
    border: "1px solid #ccc",
    background: "#f4f4f4",
    fontSize: 15,
  },

  updateBtn: {
    width: "100%",
    marginTop: 25,
    background: "green",
    color: "#fff",
    border: "none",
    padding: 14,
    borderRadius: 8,
    cursor: "pointer",
    fontWeight: "bold",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    gap: 10,
    fontSize: 16,
  },
};